export default __webpack_public_path__ + "static/media/cosyfish-bg.107b6ba5.webp";